var PROGRESS_HIDDEN_CLASS = 'gw-progress_hidden';

export default [function () {
    return {
        restrict: 'E',
        template: '<gw-progress-bounce />',
        scope: {},
        link: function link($scope, $element) {
            $element.addClass(PROGRESS_HIDDEN_CLASS);
            setTimeout(function () {
                return $element.removeClass(PROGRESS_HIDDEN_CLASS);
            }, 1);
        }
    };
}];


//////////////////
// WEBPACK FOOTER
// ./common/js/src/edge/platform/widgets/loading/ProgressDirective.js
// module id = 1990
// module chunks = 0